import {computed, ref} from "vue";

export default function useFormInput  (props)
{
    let errors = ref([])
    let gotError = computed( () => errors.value.length > 0 );
    let errorMessage = computed( () => errors.value.join("") );
    let cssInputClass = computed ( () => gotError.value ? "has-errors" : "");


    let value = ref("");

    function getData ()
    {
        return {"field": props.field?.key, "value" : value?.value ?? ''};
    }

    function setError (messages)
    {

        errors.value = messages;

    }

    function clearError ()
    {
        errors.value = [];
    }

    function setValue (newValue)
    {
        value.value = newValue;
    }



    let key = ref(props.field.key);
    const exposed = { getData, setError, clearError, setValue, key };

    return { errors, gotError, errorMessage, cssInputClass, value, getData, setError, clearError, setValue, key, exposed }
}
